<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="400px">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            {{ title }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation>
                                    <v-text-field 
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.name')" 
                                        v-model="data.name"
                                        :rules="rules.name" 
                                        dense
                                        required
                                        outlined
                                    ></v-text-field>
                                    <v-text-field 
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.identCode')" 
                                        v-model="data.gwid"
                                        :rules="rules.gwid" 
                                        disabled
                                        dense
                                        required
                                        outlined
                                    ></v-text-field>
                                    <v-select
                                        :items="shop"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.shopName')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.shopID"
                                        :rules="rules.shopID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="scheduler"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.scheduler')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.scheduleID"
                                        :rules="rules.scheduleID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="smsNet"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.smsNet')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.smsgatewayID"
                                        :rules="rules.smsgatewayID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="userAc"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.userAc')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.usercheckID"
                                        :rules="rules.usercheckID" 
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="macAc"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.macAc')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.maccheckID"
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="phoneAllowList"
                                        :label="$vuetify.lang.t('$vuetify.portalManage.ac.table.phoneAllowList')"
                                        item-text="name"
                                        item-value="id"
                                        v-model="data.phoneAllowListId"
                                        dense
                                        outlined
                                        clearable
                                    ></v-select>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="handleClose" :loading="statusModel">
                            {{$vuetify.lang.t('$vuetify.portalManage.close')}}
                        </v-btn>
                        <v-btn color="primary" @click="handleUpdate" :loading="statusModel || loading">
                            {{$vuetify.lang.t('$vuetify.portalManage.update')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import * as api from '../../../api'
import { Notification } from 'element-ui';

export default {

    props: {
        role : Number,
        group: Array
    },

    data () {
        return {

            title: this.$vuetify.lang.t('$vuetify.portalManage.ac.insertBtn'),

            dialog: false,

            statusModel: false,

            loading: false,

            shop: [],
            scheduler: [],
            smsNet: [],
            userAc: [],
            macAc: [],
            phoneAllowList: [],

            data: {
                name: null,
                gwid: null,
                groupID: null,
                shopID: null,
                scheduleID: null, 
                smsgatewayID: null,
                usercheckID: null,
                maccheckID: null,
                phoneAllowListId: null
            },

            rules: {
                name: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.name')
                ],
                gwid: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.identCode')
                ],
                shopID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.shopName')
                ],
                scheduleID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.scheduler')
                ],
                smsgatewayID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.smsNet')
                ],
                usercheckID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.portalManage.ac.rules.userAc')
                ]
            }
            
        }
    },

    methods: {

        handleOpen (item) {
            this.data = this.newObject(item);
            this.data.shopID = this.data.shopID === null ? 0 : this.data.shopID;
            this.changeGroup(this.data.groupID);
            this.dialog = true;
        },

        handleClose () {
            this.dialog = false;
            this.$refs.form.reset();
        },

        newObject (item) {
            var data = JSON.stringify(item);
            return JSON.parse(data)
        },

        handleUpdate () {
            if (this.$refs.form.validate()) {
                this.data.shopID = this.data.shopID === 0 ? null : this.data.shopID;
                this.$http.post(api.default.portal.acEditUrl, this.data).then(resp => {
                    // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                    if (!resp) return;
                    Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.userManage.success')
                    });
                    this.$emit('handleSearch');
                }).finally(resp => {
                    this.loading = false;
                    this.handleClose();
                })
            }
        },

        changeGroup (value) {
            this.getShop(value);
            this.getScheduler(value);
            this.getSmsGateway(value);
            this.getRadcheck(value);
        }, 

        getShop (value) {
            this.$http.post(api.default.rbac.shopListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.shop = resp.data.list;
                this.shop.splice(0, 0, {
                    id: 0,
                    name: '所有场所'
                })
            })
        },

        getScheduler(value){
            this.$http.post(api.default.portal.scheduleListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.scheduler = resp.data.list;
            })
        },

        getSmsGateway (value) {
            this.$http.post(api.default.portal.gatewayListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.smsNet = resp.data;
            })
        },

        getRadcheck (value) {
            this.$http.post(api.default.portal.radcheckListUrl, {
                pagenum : 1,
                pagesize: 1000,
                groupID : value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.userAc = resp.data.list;
                this.macAc = resp.data.list;
                this.phoneAllowList = resp.data.list;
            })
        }

    }
}
</script>

<style scoped>



</style>